import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BackendService {

  constructor(private http: HttpClient) { }


  read(table, filters={}, tags=[]) {
    let path = '';
    if(table === 'centers') {
      path = 'assets/health.json';
    }
    if( table === 'companies') {
      path = 'assets/companies.json';
    }
    if ( table === 'hcp' ){
      path = 'assets/hcp.json';
    }



    return this.http.get(path).pipe(  map( data =>  {

      let dat = data["Sheet1"];

      let res = { 'columns': this.getCols(dat) };

      if (tags.length > 0){
        dat = this.tagBy(dat, tags);
      }
      if( Object.keys(filters).length > 0){
        console.log(filters);
        dat = this.filterBy(dat, filters);
      }

      res['data'] = dat;

      return res;
    }));
  }

  getCols(dat){
    let res = {};
    let cols = [];
    dat.map( d => cols = cols.concat(Object.keys(d)) );
    Array.from(new Set(cols)).map( c => {
      res[c] = this.getCol(dat, c);
    });
    return res;
  }

  public tagBy(dat, tags){
    let data = JSON.parse(JSON.stringify(dat));
    let res = [];
    for (let d of data){
      let one = Object.keys(d).map(k => d[k]).join('--').toLowerCase();
      let b = true;
      for(let f of tags ){
        b = b && one.includes( f.toLowerCase() );
      }
      if (b){
        res.push(d);
      }
    }
    return res;
  }


  filterBy(data, filters){
    let res = [];
    for ( let col in filters){
      let arr = filters[col];
      if ( Object.prototype.toString.call( arr ) !== '[object Array]' ){
        arr = [ arr ];
      }

      for( let ff of arr ){
        res = res.concat( data.filter( d => d[col] === ff ) );
      }
    }
    res = Array.from( new Set(res) );
    return res;
  }

  getCol(data, col){
    return Array.from(new Set(data.map(d => d[col]))).filter(d => d !== '' && d !== undefined);
  }

  countBy(data, col) {
    let res = {};
    let reducer = (counter, term) => {
      if( term === undefined){
        return  counter;
      }
      if (!counter[term]) {
        counter[term] = 1;
      } else {
        counter[term] = counter[term] + 1;
      }
      return counter;
    };
    res = data.map(d => d[col]).reduce(reducer, res);
    let ress = [];
    Object.keys(res).map(k => ress.push( {name: k, value: res[k]} ) );
    return ress;
  }


  groupBy(data, col, gcol){
    let grps = Array.from(new Set(data.map(d => d[gcol])));
    let res = [];
    for ( let g of grps){
      let r = {};
      r['name'] = g;
      let fils = {};
      fils[gcol] = g;
      r['series'] = this.countBy( this.filterBy(data, fils), col);
      res.push(r);
    }
    return res;
  }
}
